import { InformationIcon } from '@strata/react-status-icons';

interface GridHeaderWithInfoProps {
    header: string;
    tooltipText: string;
}

export const GridHeaderWithInfo = ({ header, tooltipText }: GridHeaderWithInfoProps) => (
    <div className="sds_grid-header-with-info">
        <span className="sds_grid-header-with-info__text">{header}</span>
        <InformationIcon tooltipText={tooltipText} />
    </div>
);
